import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import type { Message } from 'primeng/api';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';
import { AuthControlService } from '@medsurf/flat-services';

@Injectable()
export class BaseGuardChainFacade {
  constructor(protected store: Store,
              protected actions$: Actions,
              protected authControlService: AuthControlService) {
  }

  //<editor-fold desc="Selectors">

  user$ = this.store.select(FlatStates.AuthControlState.currentUser$);

  //</editor-fold>

  //<editor-fold desc="Snapshot Selectors">

  snapshot_isAuthenticated = () => this.store.selectSnapshot(FlatStates.AuthControlState.isAuthenticated$);
  snapshot_user = () => this.store.selectSnapshot(FlatStates.AuthControlState.currentUser$);

  //</editor-fold>

  //<editor-fold desc="Actions">

  ofActionDispatchedMeSuccess = this.actions$.pipe(ofActionDispatched(FlatActions.AuthControlActions.MeSuccess));

  //</editor-fold>

  //<editor-fold desc="Requests">

  requestMe() {
    return this.store.dispatch(new FlatActions.AuthControlActions.Me());
  }

  requestSetActivatedRoute(next: ActivatedRouteSnapshot) {
    return this.store.dispatch(new FlatActions.NavigationControlActions.SetActivatedRoute(next));
  }

  requestAddAlert(message: Message) {

    return this.store.dispatch(new FlatActions.AlertControlActions.AddAlert(message));
  }


  requestResetQuiz() {
    return this.store.dispatch(new FlatActions.TrainingSharedActions.Reset());
  }

  setRedirectUrl(url: string) {
    return this.authControlService.setRedirectUrl(url);
  }

  //</editor-fold>
}
